import { render, staticRenderFns } from "./ArticleLabel.vue?vue&type=template&id=5b65774d&scoped=true&"
import script from "./ArticleLabel.vue?vue&type=script&lang=js&"
export * from "./ArticleLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b65774d",
  null
  
)

export default component.exports